import { __decorate, __metadata } from 'tslib';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCRechargePhone = class UiCRechargePhone {
    constructor() {
        this.repeatRechage = new EventEmitter();
        this.emitPhoneNumber = new EventEmitter();
    }
    ngOnInit() { }
    repeatRechagePhone() {
        this.repeatRechage.emit();
    }
    onChangePhone(event) {
        console.log(event);
        this.emitPhoneNumber.emit(event);
    }
};
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRechargePhone.prototype, "listOperators", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCRechargePhone.prototype, "rechargeNumberForm", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRechargePhone.prototype, "lastNumberRecharge", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRechargePhone.prototype, "repeatRechage", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCRechargePhone.prototype, "emitPhoneNumber", void 0);
UiCRechargePhone = __decorate([
    Component({
        selector: 'ui-c-recharge-phone-number',
        template: "<div class=\"recharge-phone-number\">\n  <form [formGroup]=\"rechargeNumberForm\">\n\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-item lines=\"full\">\n          <ion-label position=\"stacked\"> {{'RECHARGE_PHONE.LABELS.PHONE_NUMBER' | wlpTranslate}}</ion-label>\n          <ion-input (change)=\"onChangePhone($event)\" formControlName=\"phoneNumber\" [brmasker]=\"{phone: true}\"\n            maxLength=\"15\" placeholder=\"(XX) X XXXX-XXXX\"></ion-input>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-item lines=\"full\">\n          <ion-label position=\"stacked\"> {{'RECHARGE_PHONE.LABELS.OPERATOR_NUMBER' | wlpTranslate}} </ion-label>\n          <ion-select formControlName=\"operator\" placeholder=\"XXXXXXX\"\n            [cancelText]=\"'RECHARGE_PHONE.BUTTONS.CANCEL'  | wlpTranslate\"\n            [okText]=\"'RECHARGE_PHONE.BUTTONS.OK'  | wlpTranslate\">\n            <ion-select-option *ngFor=\"let item of listOperators\" [value]=\"item.id\">{{item.title}}\n            </ion-select-option>\n          </ion-select>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n  </form>\n\n  <ng-container *ngIf=\"lastNumberRecharge != null\">\n    <ion-item lines=\"none\" (click)=\"repeatRechagePhone()\">\n      <ion-label>\n        {{'RECHARGE_PHONE.LABELS.REPEAT_RECHARGE' | wlpTranslate}}\n      </ion-label>\n    </ion-item>\n    <ion-item lines=\"none\" (click)=\"repeatRechagePhone()\">\n      <ion-label> ({{lastNumberRecharge?.ddd}}) - {{lastNumberRecharge?.phone}} -\n        {{lastNumberRecharge?.operatorDescription}} </ion-label>\n      <ion-icon name=\"repeat-outline\"></ion-icon>\n    </ion-item>\n  </ng-container>\n</div>",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCRechargePhone);

let UiCRechargePhoneNumberModule = class UiCRechargePhoneNumberModule {
};
UiCRechargePhoneNumberModule = __decorate([
    NgModule({
        declarations: [UiCRechargePhone],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            NgxMaskIonicModule,
            UiBsTranslateModule,
        ],
        exports: [UiCRechargePhone]
    })
], UiCRechargePhoneNumberModule);

export { UiCRechargePhone, UiCRechargePhoneNumberModule };
//# sourceMappingURL=wlp-ui-c-recharge-phone-number.js.map
